import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import CodeEditor from "../../../components/CardDropdown/automacoes/funcoes/codeEditor";
import {
  Md1KPlus,
  MdEditDocument,
  MdFolder,
  MdInput,
  MdOutput,
} from "react-icons/md";
import "../../../assets/css/funcoes.css";
import Arquivos from "./Arquivos";
import Parametros from "./Parametros";
import funcoes from "../../../models/funcoes";
import FuncaoGeral from "./FuncaoGeral";
import comum from "../../../helpers/comum";
import { FaPlus } from "react-icons/fa";
import FuncoesContants from "../../../constants/FuncoesContants";
import { toast } from "react-toastify";

const ActiveTab = {
  FUNCOES: "Funções",
  GERAL_FUNCAO: "Visual Workflow",
  PARAMETROS_ENTRADA: "Parâmetros de Entrada",
  PARAMETROS_SAIDA: "Saída da Função",
};

function Funcoes() {
  const [functions, setFunctions] = useState([]);

  const [activeFunction, setActiveFunction] = useState(null);
  const [active, setActive] = useState(ActiveTab.FUNCOES);

  const onSave = async () => {
    const paramsNames = activeFunction.params.map((e) => e.label);
    if (comum.hasDuplicates(paramsNames)) {
      toast.error(
        "Não é permitido que os nomes dos parâmetros de entrada e/ou saída de uma função sejam duplicados."
      );
      return;
    }
    setFunctions(
      functions.map((e) => {
        if (e.id === activeFunction.id) {
          return activeFunction;
        }
        return e;
      })
    );

    const final = await funcoes.save(activeFunction);

    if (final) {
      toast.success("Função salva com sucesso!");
    } else {
      toast.error("Não foi possivel salvar, por favor tente novamente.");
    }
  };

  const onRemoveParam = (id) => {
    const confirmRemove = window.confirm(
      "Tem certeza que deseja remover este parâmetro?\n\n" +
        "A remoção pode impactar o funcionamento de workflows que utilizam esta função, " +
        "provocando erros ou falhas inesperadas (as modificações serão aplicadas, somente quando a função for Salva)."
    );

    if (confirmRemove) {
      setActiveFunction({
        ...activeFunction,
        params: activeFunction.params.filter((e) => e.id !== id),
      });
    }
  };

  const onSaveRename = (name) => {
    setActiveFunction({
      ...activeFunction,
      data: {
        ...activeFunction.data,
        title: name,
      },
    });
    setFunctions(
      functions.map((e) => {
        if (e.id === activeFunction.id) {
          return {
            ...e,
            data: {
              ...e.data,
              title: name,
            },
          };
        }
        return e;
      })
    );
  };

  const addFunction = async () => {
    const userConfirmed = window.confirm(
      "Você tem certeza que deseja criar uma nova função?"
    );

    if (!userConfirmed) {
      return;
    }

    const body = { ...FuncoesContants.NEW_FUNCTION, id: null };

    try {
      const sd = await funcoes.save(body);
      if (!sd) {
        toast.error("Não foi possível criar uma nova função, tente novamente.");
        return;
      }

      const mfcs = await start(false);
      setActiveFunction(mfcs.find((e) => e.id === sd.id));

      if (mfcs) {
        toast.success("Nova função criada com sucesso!");
      }
    } catch (error) {
      toast.error("Erro ao salvar a função. Tente novamente.");
    }
  };

  const onChage = (code) => {
    setActiveFunction({
      ...activeFunction,
      code,
    });
  };

  const start = async (selected = true) => {
    const res = await funcoes.list_all();
    setFunctions(res);
    if (selected) setActiveFunction(res.length > 0 ? res[0] : null);
    return res;
  };

  const onAddParam = async (type = "input") => {
    // Type só pode ser input / output
    // É possivel que o front adicione parametros novos fora de escopo, dentro da pipeline, por isso o obrigatory:true
    const res = {
      id: comum.GenerateId(),
      key: comum.GenerateId(20),
      label: "Novo Paramerto",
      type: type,
      variable_type: "",
      obrigatory: true,
    };

    setActiveFunction({
      ...activeFunction,
      params: [...activeFunction.params, res],
    });
  };

  const onChageParam = (id, key, value) => {
    setActiveFunction({
      ...activeFunction,
      params: activeFunction.params.map((e) => {
        if (e.id === id)
          return {
            ...e,
            [key]: value,
          };
        return e;
      }),
    });
  };

  const onChangeGeralParam = (key, value) => {
    setActiveFunction({
      ...activeFunction,
      data: {
        ...activeFunction.data,
        type: {
          ...activeFunction.data.type,
          [key]: value,
        },
      },
    });
  };

  const onPressVariable = (misn) => {
    const dina = activeFunction?.params?.find((e) => e.id == misn.id);
    let tsr = "";

    if (dina.type === "input") {
      const provisoria = dina.label.replace(" ", "_").toLowerCase();
      tsr = `${provisoria} = self.get_param_value("${dina.label}")`;
    } else {
      tsr = `self.set_result("${dina.label}", "VALOR_DESEJADO")`;
    }
    comum.copyToClipboard(tsr);
    toast.success(
      `O Parâmetro de ${
        dina.type === "input" ? "entrada" : "saída"
      } foi copiado para sua área de transferência!`
    );
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <Row className="active-container">
      <Col md={3} style={{ padding: 0 }}>
        <div className="sidebar-container">
          <div>
            <nav className="nav active-nav flex-column">
              <span
                className={`nav-link active-nav-link ${
                  active === ActiveTab.FUNCOES ? "active" : ""
                }`}
                href="#"
                onClick={() => setActive(ActiveTab.FUNCOES)}
              >
                <MdFolder size={20} />
              </span>

              <span
                className={`nav-link active-nav-link ${
                  active === ActiveTab.GERAL_FUNCAO ? "active" : ""
                }`}
                href="#"
                onClick={() => setActive(ActiveTab.GERAL_FUNCAO)}
              >
                <MdEditDocument size={20} />
              </span>

              <span
                className={`nav-link active-nav-link ${
                  active === ActiveTab.PARAMETROS_ENTRADA ? "active" : ""
                }`}
                href="#"
                onClick={() => setActive(ActiveTab.PARAMETROS_ENTRADA)}
              >
                <MdInput size={20} />
              </span>

              <span
                className={`nav-link active-nav-link ${
                  active === ActiveTab.PARAMETROS_SAIDA ? "active" : ""
                }`}
                href="#"
                onClick={() => setActive(ActiveTab.PARAMETROS_SAIDA)}
              >
                <MdOutput size={20} />
              </span>
            </nav>
          </div>
          <div style={{ width: "100%" }}>
            <div className="active-title" onClick={() => addFunction()}>
              <span className="active-item-title">{active}</span>

              {active === ActiveTab.FUNCOES && (
                <div style={{ cursor: "pointer" }}>
                  <FaPlus size={15} />
                </div>
              )}
            </div>
            {active === ActiveTab.FUNCOES ? (
              <div style={{ overflowY: "auto", height: "calc(100% - 5%)" }}>
                {functions?.map((a) => (
                  <Arquivos
                    name={a?.data?.title}
                    data={a}
                    onClick={setActiveFunction}
                    active={activeFunction?.id === a.id}
                  />
                ))}
              </div>
            ) : null}

            {active === ActiveTab.GERAL_FUNCAO && (
              <FuncaoGeral
                params={activeFunction.data}
                onChange={onChangeGeralParam}
              />
            )}

            {active === ActiveTab.PARAMETROS_ENTRADA && (
              <Parametros
                type="input"
                params={activeFunction.params.filter((e) => e.type === "input")}
                onAddParam={onAddParam}
                onChageParam={onChageParam}
                onRemoveParam={onRemoveParam}
              />
            )}

            {active === ActiveTab.PARAMETROS_SAIDA && (
              <Parametros
                type="output"
                params={activeFunction.params.filter(
                  (e) => e.type === "output"
                )}
                onAddParam={onAddParam}
                onChageParam={onChageParam}
                onRemoveParam={onRemoveParam}
              />
            )}
          </div>
        </div>
      </Col>
      <Col md={9} className="editor-container">
        <CodeEditor
          functionName={activeFunction?.data?.title}
          code={activeFunction?.code}
          onChange={onChage}
          onSave={onSave}
          onRename={onSaveRename}
          onPressVariable={(e) => onPressVariable(e)}
          variables_output={activeFunction?.params
            .filter((e) => e.type === "output")
            .map((e) => {
              return {
                id: e.id,
                label: e.label,
              };
            })}
          variables={activeFunction?.params
            .filter((e) => e.type === "input")
            .map((e) => {
              return {
                id: e.id,
                label: e.label,
              };
            })}
        />
      </Col>
    </Row>
  );
}

export default Funcoes;
